import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router } from "react-router-dom";
import { Amplify } from "aws-amplify";
import config from "./config";

Amplify.configure({
    Auth: {
        Cognito: {
            region: config.cognito.REGION,
            userPoolId: config.cognito.USER_POOL_ID,
            userPoolClientId: config.cognito.APP_CLIENT_ID,
            identityPoolId: config.cognito.IDENTITY_POOL_ID
        }
    },
    Storage: {
        S3: {
            region: config.s3.REGION,
            bucket: config.s3.BUCKET
        }
    },
    API: {
        REST: {
            portunes: {
                endpoint: config.apiGateway.URL,
                region: config.apiGateway.REGION
            }
        }
    }
});

ReactDOM.render(
    <Router>
        <App />
    </Router>,
    document.getElementById("root")
);

serviceWorker.unregister();
